import { useState } from "react";
import { Landmark, FileSpreadsheet, BarChart3, ClipboardCheck } from "lucide-react";
import { PageHeader } from "@/components/common";
import RabManager from "@/components/admin/RabManager";
import LpjRabManager from "@/components/admin/LpjRabManager";
import LpjMandiriManager from "@/components/admin/LpjMandiriManager";
import RekapKeuangan from "@/components/admin/RekapKeuangan";

const SUBS = [
  { v: "rekap", l: "Rekap Unit", icon: BarChart3 },
  { v: "rab", l: "RAB", icon: Landmark },
  { v: "lpjrab", l: "LPJ RAB", icon: ClipboardCheck },
  { v: "mandiri", l: "LPJ Mandiri", icon: FileSpreadsheet },
];

export default function KeuanganManager() {
  const [sub, setSub] = useState("rekap");
  return (
    <div className="space-y-5" data-testid="keuangan-manager">
      <PageHeader icon={Landmark} title="Keuangan Unit" subtitle="RAB, realisasi, & LPJ per unit Departemen / Ribath. Terpisah dari Buku Kas Kasir." />
      <div className="inline-flex flex-wrap rounded-xl bg-emerald-100/60 dark:bg-white/5 p-1" data-testid="keuangan-subtab">
        {SUBS.map((s) => (
          <button key={s.v} data-testid={`keuangan-sub-${s.v}`} onClick={() => setSub(s.v)}
            className={`px-4 py-1.5 text-sm font-semibold rounded-lg transition-all inline-flex items-center gap-2 ${sub === s.v ? "bg-emerald-700 text-white shadow" : "text-emerald-800 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-white/5"}`}>
            <s.icon className="h-4 w-4" /> {s.l}
          </button>
        ))}
      </div>
      {sub === "rekap" ? <RekapKeuangan /> : sub === "rab" ? <RabManager /> : sub === "lpjrab" ? <LpjRabManager /> : <LpjMandiriManager />}
    </div>
  );
}
